import { SearchFormState } from '../reducers';

export const getPassengersConfig = (state: SearchFormState) => state.passengersConfig;
